<script>
import { mapActions, mapState } from 'vuex'

import ReservationVm from './reservation-vm.vue'

export default {
  components: {
    ReservationVm,
  },

  computed: {
    ...mapState({
      current: state =>
        state.reservation.current,
      reservation_transaction: state =>
        state.reservation.reservation_transactions.find(
          t => t.id === state.reservation.current.id
        ),
      infrastructure_instances: state =>
        state.infrastructure.infrastructure_instances,
      image_blueprints: state =>
        state.image.image_blueprints,
      image_flavors: state =>
        state.image.image_flavors,
      image_groups: state =>
        state.image.image_groups,
      image_snapshots: state =>
        state.image.image_snapshots,
      image_tiers: state =>
        state.image.image_tiers,
      topology_groups: state =>
        state.topology.topology_groups
    }),

    isVisible: function () {
      return this.reservation_transaction &&
        this.current.is_visible
    },

    branchImageTiers: function () {
      return _.chain(this.image_tiers)
        // Filter by image tier id
        .filter(function (item) {
          return item.attributes.tier_type == 'Branch'
        })
        // Order by column and direction
        .orderBy(['attributes.tier_alias'], ['desc'])
        .value()
    },

    wanImageTiers: function () {
      return _.chain(this.image_tiers)
        // Filter by image tier id
        .filter(function (item) {
          return item.attributes.tier_type == 'WAN'
        })
        // Order by column and direction
        .orderBy(['attributes.tier_alias'], ['asc'])
        .value()
    },

    datacenterImageTiers: function () {
      return _.chain(this.image_tiers)
        // Filter by image tier id
        .filter(function (item) {
          return item.attributes.tier_type == 'Datacenter'
        })
        // Order by column and direction
        .orderBy(['attributes.tier_alias'], ['asc'])
        .value()
    },
  },

  methods: {
    imageGroupByTier: function (tier_id) {
      let topology_group = this.topology_groups
        .find(
          g => g.attributes.image_tier_id == tier_id
        )

      if(topology_group == undefined) {
        return []
      }

      return this.image_groups.find(
        g => g.id == topology_group.attributes.image_group_id
      )
    },

    instancesByTier: function (tier_id) {
      return this.infrastructure_instances.map(function(infrastructure_instance) {
        let image_blueprint = this.image_blueprints.find(
          b => b.id == infrastructure_instance.attributes.image_blueprint_id
        )
        let image_flavor = this.image_flavors.find(
          f => f.id == infrastructure_instance.attributes.image_flavor_id
        )
        let image_snapshot = this.image_snapshots.find(
          s => s.id == infrastructure_instance.attributes.image_snapshot_id
        )

        return {
          'infrastructure_instance': infrastructure_instance,
          'image_blueprint': image_blueprint,
          'image_flavor': image_flavor,
          'image_snapshot': image_snapshot
        }
      }, this)
      .filter(function (instance) {
        return instance.image_blueprint.attributes.image_tier_id == tier_id
      })
      .sort(function(a, b) {
          let textA = a.image_blueprint.attributes.blueprint_name.toUpperCase()
          let textB = b.image_blueprint.attributes.blueprint_name.toUpperCase()
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
      })
    },
  }
}
</script>
